var CONTRACT = '0xc9029Cc9619146e22D4E840cC5BdE4E233B312fa';
var ABI = ['function balanceOf(address owner) view returns (uint256)'];

function unlockVault(){
    document.body.classList.remove('vault-locked');
    document.body.classList.add('vault-unlocked');
    try { 
        localStorage.setItem('wallet-verified', '1'); 
        document.getElementById("logout-btn").style.display = "none"; 
    } catch(e){}
}

function lockVault(){
    document.body.classList.remove('vault-unlocked');
    document.body.classList.add('vault-locked');
    try { 
        localStorage.removeItem('wallet-verified'); 
    } catch(e){}
}

  async function verify(address, silent, statusEl){
    try {
      // 1. Validierung
      if(!ethers.utils.isAddress(address)){
        console.error("Ungültige Adresse:", address);
        if(!silent && statusEl) statusEl.textContent = 'Invalid address.';
        return;
      }

      if(!silent && statusEl) statusEl.textContent = 'Checking ownership…';
      
      // 2. Provider sicher initialisieren
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      
      // WICHTIG: Force Refresh des Accounts beim Provider
      // Dies stellt sicher, dass der Provider den aktuellen Account kennt
      await provider.send("eth_requestAccounts", []); 
      
      const net = await provider.getNetwork();
      
      if(net.chainId !== 1){
        try {
          await window.ethereum.request({ 
            method:'wallet_switchEthereumChain', 
            params:[{ chainId:'0x1' }] 
          });
          // Nach Switch Provider neu laden
          await provider.send("eth_requestAccounts", []); 
        } catch(e){
          if(!silent && statusEl) statusEl.textContent = 'Please switch to Ethereum mainnet.';
          return;
        }
      }

      // 3. DEBUGGING: Logge alles, was wir tun
      console.log("🔍 Checking Contract:", CONTRACT);
      console.log("🔍 Address:", address);
      console.log("🔍 Chain ID:", net.chainId);

      const contract = new ethers.Contract(CONTRACT, ABI, provider);
      
      // Prüfen, ob der Contract überhaupt erreichbar ist
      const contractCode = await provider.getCode(CONTRACT);
      if(contractCode === '0x') {
        throw new Error("Contract address is empty or invalid");
      }

      const bal = await contract.balanceOf(address);
      
      // 🔥 CRITICAL DEBUG OUTPUT
      console.log("💰 Raw Balance Result:", bal.toString());
      console.log("💰 Is Greater Than 0?", bal.gt(0));

      if(bal.gt(0)){
        console.log("✅ Access Granted for:", address);
        if(!silent && statusEl) statusEl.textContent = 'Access granted.';
        unlockVault();
      } else if(!silent){
        console.log("❌ No token found for:", address);
        if(statusEl) statusEl.textContent = 'No Vault token found at this address.';
        lockVault();
      } else {
        console.log("❌ No token found for:", address);
        if(statusEl) statusEl.textContent = '';
        lockVault();
      }
    } catch(err){
      console.error("❌ Verification Error:", err);
      if(!silent && statusEl) statusEl.textContent = 'Verification failed: ' + err.message;
    }
  }

  async function checkWallet(){
    try {
      var accounts = await window.ethereum.request({ method:'eth_accounts' });
      if(accounts && accounts.length) { 
          console.log("🔍 Address:", accounts[0]);
          await verify(accounts[0], true, null);
          try { walletVerified = localStorage.getItem('wallet-verified') === '1'; } catch(e){}
          if(!walletVerified){
              window.location.href = '/pages/vault';
          }
      } else {
          console.error("❌ No Address Found");
          lockVault();
          window.location.href = '/pages/vault';
      }
    } catch(err){
        console.error("❌ Verification Error:", err);
        lockVault();
        window.location.href = '/pages/vault';
    }
  }